// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"24226bad","703":"da64e02c"}[chunkId] + ".chunk.js";
};